var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 21C11.5523 21 12 21.4477 12 22C12 22.5523 11.5523 23 11 23H7C6.44772 23 6 22.5523 6 22C6 21.4477 6.44772 21 7 21H11Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18C15.5523 18 16 18.4477 16 19C16 19.5523 15.5523 20 15 20H7C6.44772 20 6 19.5523 6 19C6 18.4477 6.44772 18 7 18H15Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 5C28.2091 5 30 6.79086 30 9V23C30 25.2091 28.2091 27 26 27H6C3.79086 27 2 25.2091 2 23V9C2 6.79086 3.79086 5 6 5H26ZM4 23C4 24.1046 4.89543 25 6 25H26C27.1046 25 28 24.1046 28 23V13H4V23ZM6 7C4.89543 7 4 7.89543 4 9V10H28V9C28 7.89543 27.1046 7 26 7H6Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.e1786d439652f932675eb788443d2dff.svg";
export { ForwardRef as ReactComponent };